import { render, staticRenderFns } from "./upload_file.vue?vue&type=template&id=4b264171&"
import script from "./upload_file.vue?vue&type=script&lang=js&"
export * from "./upload_file.vue?vue&type=script&lang=js&"
import style0 from "./upload_file.vue?vue&type=style&index=0&id=4b264171&prod&lang=less&"
import style1 from "./upload_file.vue?vue&type=style&index=1&id=4b264171&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports